import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  drugGroups: [],
  allDrugGroups: [],
  totalPages: 0,
  totalRecords: 0,
  drugGroup: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_24: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_DrugGroups(state, drugGroups) {
    state.drugGroups = drugGroups.items;
    state.totalPages = drugGroups.totalPages;
    state.totalRecords = drugGroups?.totalRecords ?? 0;
  },
  SET_AllDrugGroups(state, drugGroups) {
    state.allDrugGroups = drugGroups;
  },
  SET_DrugGroup(state, drugGroup) {
    state.drugGroup = drugGroup;
  },
};
const actions = {
  errorDrugGroup({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllDrugGroups({ commit, dispatch, rootState }) {
    return apiClient
      .get('/DrugGroups/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllDrugGroups', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrugGroup', error);
      });
  },
  addDrugGroup({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/DrugGroups', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrugGroup', error);
      });
  },
  getDrugGroup({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/DrugGroups/ById?drugGroupId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DrugGroup', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrugGroup', error);
      });
  },
  editDrugGroup({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/DrugGroups/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrugGroup', error);
      });
  },
  deleteDrugGroup({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/DrugGroups/Remove?drugGroupId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDrugGroup', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
